import React from 'react';

function PrimaryButton({ title, onClick, type, className, loading, loadingInside, ...buttonProps }) {
    return (
        <button 
            disabled={loading || buttonProps.disabled}
            className={`${className || 'button'} ${loadingInside ? 'button--left' : ''}`}
            onClick={onClick}
            type={type || 'button'}
            {...buttonProps}
        >
            {title}
            {loading && (
                <div class={`lds-ring lds-ring--button ${loadingInside ? 'lds-ring--left' : ''}`}><div></div><div></div><div></div><div></div></div>
            )}
        </button>
    )
}

export default PrimaryButton;
